import { setContext, ContextSetter } from 'apollo-link-context';
import { createQueryAndMutateFunctions } from './common';
import { ENDPOINTS } from '@/settings/endpoints';

const FORUM_AUTH_TOKEN = process.env.VUE_APP_GRAPH_CMS_FORUM_TOKEN || '';

export const forumAuth: ContextSetter = (_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${FORUM_AUTH_TOKEN}`,
    },
  };
};

const forumAuthLink = setContext(forumAuth);

export const { query: forumQuery, mutate: forumMutation } = createQueryAndMutateFunctions(
  ENDPOINTS.forum,
  forumAuthLink,
);
